/**
 * TKP-27 / 6.2 (kriter 4) — kopyalama kısayolu için sayfadaki aktarımları düzleştirir: her kayıt hangi ilgili kişi
 * satırına ait, hangi 3. tarafa; form bu listeden seçileni kopyalar. Saf: store'a bağımlı değil.
 */
export const flattenCopySources = (datasubjectInventory = {}, rowsById = {}, translate = (n) => n) =>
  Object.entries(datasubjectInventory).flatMap(([rowId, inv]) =>
    (inv?.transferings ?? []).map((t) => ({
      ...t,
      sourceRowId: rowId,
      label: `${translate(rowsById[rowId]?.name) ?? rowId} → ${translate(t.thirdParty?.name) ?? "?"}`,
    }))
  );

/** Düğüm payload'undan satır sözlüğü (`_id` → satır) — kopyalama etiketi ve panel başlıkları için. */
export const indexDatasubjectRows = (departments = []) => {
  const out = {};
  for (const d of departments) for (const p of d.processes ?? []) for (const n of p.processDatas ?? []) for (const r of n.datasubjects ?? []) out[r._id] = { ...r, node: n, process: p, department: d };
  return out;
};
